/**
 * Route Type Definitions
 * Route metadata and requirements for navigation
 */

import { UserRole, UserPermission } from './user.types';

/**
 * Route metadata for access control
 */
export interface RouteMetadata {
  /** Route requires authentication */
  requiresAuth: boolean;
  /** Allowed roles for this route */
  allowedRoles?: UserRole[];
  /** Required permissions for this route */
  requiredPermissions?: UserPermission[];
  /** Route title for breadcrumbs/tabs */
  title?: string;
  /** Route description */
  description?: string;
}

/**
 * Route state for persistence
 */
export interface RouteState {
  /** Current route path */
  pathname: string;
  /** Query parameters */
  search: string;
  /** Timestamp of last visit */
  timestamp: number;
}

/**
 * Session storage keys
 * Access token is stored separately in localStorage via utils/auth-token.ts
 */
export const STORAGE_KEYS = {
  LAST_ROUTE: 'lastRoute',
  USER_DATA: 'userData',
} as const;
